import { render, staticRenderFns } from "./the-settings.vue?vue&type=template&id=3c6886d4"
import script from "./the-settings.vue?vue&type=script&lang=js"
export * from "./the-settings.vue?vue&type=script&lang=js"
import style0 from "./the-settings.vue?vue&type=style&index=0&id=3c6886d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports